// const dynamicallyUnloadCss = (filename, filetype) => {
//   var elements = document.getElementsByTagName('link');
//   elements.forEach((element)=>{
//     if (element &&
//         element.getAttribute('href')!=null &&
//         element.getAttribute('href').indexOf(filename) !== -1){
//       element.parentNode.removeChild(element);
//     }
//   });

// }

import { data } from '../version/dataVersion';
import { isRtl } from '../library/constants';

export default function register() {

  const cacheBust = data.version;

  const dynamicallyLoadCss = (file) => {
    const link = document.createElement('link');
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.onload = function(){ /*CSSDone();*/ }
    link.setAttribute("href", '/canvas-tree/css/' + file + '?cacheBust=' + cacheBust);
    document.getElementsByTagName("head")[0].appendChild(link);
  }

  if(isRtl) dynamicallyLoadCss('rtl.css');
  // dynamicallyLoadCss('antd_custom.css');
  dynamicallyLoadCss('adaptedFamilytreeForms.css');
};


